export const DOCUMENTS_PAGE_MODALS = {
  uploadTemplate: 'uploadTemplate',
  placeholderList: 'placeholderList',
};
